import EnvConfig from './envConfig';
import content from '../constants/content';
/**
 * api endpoint configuration imported and passed to httpService from each components
 * Release 29.5: added the EYKTDFCollateralID, EYKTDFAssociatedDataAssetsID
 */
const CommonAPiConfig = {
    Cards: {
        selectProperties: "Title,EYKDDescription,EYKDTileImagePath,EYKDLicenseStatus,Path,EYKDCollateralID,EYKTDFCollateralID,ListItemID,EYKDProviderUrl,EYKDTileImagePath,EYKDBannerImagePath,owstaxIdEYKDSector,owstaxIdEYKDServiceLine,owstaxIdEYKDGeoScope,owstaxIdEYKDGeoAccess,EYKDAssetType,owstaxIdEYKDLanguage,EYKDLicenseStatus,EYKDProviderType,EYKDContactsOWSUSER,EYKDLastUpdatedDate,EYKDViewCount,EYKDTitle,EYKDRegistration,EYKDAccessUrl,EYKDAccessInformation,EYKDSolutions,EYKDLearningMaterials,EYKDSupport,EYKDOnlineResources,EYKDBestPractisesUseCases,EYKDCopyright,EYKDRestrictions,EYKDExternalRedistribution,EYKDInternalRedistribution,EYKDTopics,owstaxIdEYKDCategory,EYKDAssociatedDataAssetsID,EYKTDFAssociatedDataAssetsID,EYKDAssociatedDataProviderID,EYKDAssociatedDataProvider,EYKDAccessButtonLabel,EYKDAccessRequest,EYContentType,Created,EYKDDataDelivery,CreatedBy,AuthorOWSUSER"
    },
    refinersList: {
        refiners: "owstaxIdEYKDSector(filter=1000/0/*),owstaxIdEYKDServiceLine(filter=1000/0/*),owstaxIdEYKDGeoAccess(filter=1000/0/*),owstaxIdEYKDGeoScope(filter=1000/0/*),EYKDLicenseStatus(sort=name/ascending),EYKDTopics(sort=name/ascending),EYKDDataDelivery(sort=name/ascending),owstaxIdEYKDCategory(filter=1000/0/*)"
    }
};

const ApiConfig = {
    baseUrl: {
        local: "https://acemwpddscapiweb01.azurewebsites.net",
        // DEV
        // development: "https://eundinth59wap08.azurewebsites.net",
        // qa: "https://api-clientdata-mvp.discover.ey.com",
        // UAT
        development: "https://api-clientdata-mvp.discover.ey.com",
        qa: "https://api-clientdata-mvp.discover.ey.com",
        prod: "https://api.discover.ey.com"
    },
    appBaseUrl: {
        local: "http://localhost:3000",
        development: "https://data-dev.discover.ey.com",
        qa: "https://data-qa.discover.ey.com",
        prod: "https://data.discover.ey.com"
    },
    header: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    endpointConfig: {
        peopleProfile: {
            params: "?accountname=i:0%23.f%7cmembership%7c{email}"
        },
        detailData: {
            method: 'GET',
            endpoint: '/details'
        },
        homePageData: {
            method: 'GET',
            endpoint: '/homePageData'
        },
        collateralAndPeople: {
            method: 'POST',
            endpoint: '/v1/data/dataassetdetails',
            data: {
                relatedAssetsQuery: {
                    ...EnvConfig.RelatedAssets,
                    ...CommonAPiConfig.Cards
                }
            }
        },
        getGlossaryData: {
            method: 'GET',
            endpoint: '/v1/data/glossary'
        },
        getWhatsNewData: {
            method: 'GET',
            endpoint: '/v1/data/whatsnew',
        },
        getNewJoinerData: {
            method: 'GET',
            endpoint: '/v1/data/newjoiner',
        },
        getProfilePhoto: {
            method: 'GET',
            baseUrl: 'https://graph.microsoft.com',
            endpoint: '/v1.0/me/photo/$value',
            tokenId: "readToken",
            header: {
                'Content-Type': 'image/jpg'
            }
        },
        getRecentViewJson: {
            method: 'GET',
            endpoint: '/v1/data/getRecentlyViewed'
        },
        updateRecentlyViewed: {
            method: 'POST',
            endpoint: '/v1/data/updateRecentlyViewed',
        },
        recentlyViewQuery: {
            method: 'POST',
            endpoint: '/v1/data/search/postquery',
            data: {
                ...CommonAPiConfig.Cards,
                ...EnvConfig.RecentlyView,
                querytext: "*",
                rowLimit: content.ApiRowLimit.recentlyView,
                enableSorting: true
            }
        },
        popularQuery: {
            method: 'POST',
            endpoint: '/v1/data/search/postquery',
            data: {
                ...CommonAPiConfig.Cards,
                ...CommonAPiConfig.refinersList,
                ...EnvConfig.Popular,
                querytext: "*",
                rowLimit: content.ApiRowLimit.popular,
                enableSorting: true
            }
        },
        topicQuery: {
            method: 'POST',
            endpoint: '/v1/data/search/postquery',
            data: {
                ...EnvConfig.Topic,
                querytext: "*",
                selectProperties: "Title,ListItemID,EYKDDescription,EYKDTileImagePath,EYKDLicenseStatus,Path,EYKDSortOrder",
                enableSorting: true
            }
        },
        searchResultData: {
            method: 'POST',
            endpoint: '/v1/data/search/postquery',
            data: {
                ...CommonAPiConfig.Cards,
                ...CommonAPiConfig.refinersList,
                ...EnvConfig.Results,
                querytext: "*",
                rowLimit: content.ApiRowLimit.searchResult
            }
        },
        configurationData: {
            id: 'configAPI',
            method: 'GET',
            endpoint: '/v1/data/configurations',
        },
        getHierarchicalRefinerValues: {
            id: 'termStoreAPI',
            method: 'GET',
            endpoint: '/v1/data/getTerms',
        },
        isValidEYP: {
            id: 'eypuser',
            method: 'GET',
            endpoint: '/v1/data/eypuser'
        },
        getContactPhoto: {
            method: 'POST',
            baseUrl: 'https://graph.microsoft.com',
            endpoint: '/v1.0/$batch',
            tokenId: "readToken",
            header: {
                'Content-Type': 'application/json'
            }
        },
        getContact: {
            method: 'POST',
            baseUrl: 'https://graph.microsoft.com',
            endpoint: '/v1.0/$batch',
            tokenId: "readToken",
            header: {
                'Content-Type': 'application/json'
            }
        },
        getSpoToken: {
            id: 'getspotoken',
            method: 'GET',
            endpoint: '/v1/data/getspotoken'
        },
        userLogout: {
            id: 'logout',
            method: 'GET',
            endpoint: '/v1/data/logout'
        },
        searchSuggestionsData: {
            id: 'searchSuggestionsData',
            method: 'GET',
            endpoint: `/v1/data/getQuerySuggestions?query=$value&noOfSuggestions=5`
        },
        getContactData: {
            method: 'GET',
            endpoint: '/v1/data/getContacts',
        },
        getClientDataToken: {
            method: 'GET',
            endpoint: '/v1/data/getclientdatatoken',
        },
        getClientData: {
            method: 'GET',
            endpoint: '/v1/data/getclientdata',
            header: {
                'Content-Type': 'application/json',
            }
        },
        getDefaultProvisionData: {
            method: 'GET',
            endpoint: '/v1/data/defaultprovision',
            header: {
                'Content-Type': 'application/json',
            }
        },
        getBroaderUseData: {
            method: 'GET',
            endpoint: '/v1/data/broaderuse',
            header: {
                'Content-Type': 'application/json',
            }
        },
        userAttestation: {
            method: 'POST',
            endpoint: '/v1/data/userattestation',
            header: {
                'Content-Type': 'application/json',
            },
            data: {}
        },
        clientdatasearch: {
            method: 'POST',
            endpoint: '/v1/data/clientdatasearch',
            header: {
                'Content-Type': 'application/json',
            },
            data: {}
        },
    }

};
export default ApiConfig;
